// @ts-nocheck
import LoadingTableNormal from "components/shared-components/LoadingTableNormal";
import { useTimeSlots } from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import "../OrderDetailHistory/OrderDetailHistory.scss";

const OrderDetailReminder = props => {
  const { t } = useTranslation(["order"]);

  const { data: timeSlots } = useTimeSlots({
    params: {},
    key: "time-slots-reminder",
  });

  // time-slot menu
  const timeSlotMenuDefault = timeSlots?.items?.map(item => {
    return { id: item?.id, name: item?.name };
  });

  let [data, setData] = useState(props.data);
  let [isLoading, setIsLoading] = useState(props.isLoading);
  let [isDeletingReminder, setIsDeletingReminder] = useState(
    props.isDeletingReminder
  );
  const clickDeleteHandler = row => {
    props.deleteOrderRemind(row.id);
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-trash fa-lg text-danger" />,
      text: t("detail.reminder.delete"),
      onClick: clickDeleteHandler,
    },
  ];
  const [rowActions, setRowActions] = useState(listRowAction);
  useEffect(() => {
    setData(props.data);
  }, [props.data]);
  useEffect(() => {
    setIsLoading(props.isLoading);
  }, [props.isLoading]);

  return (
    <Card>
      <CardBody>
        <CardTitle>{t("detail.reminder.title")}</CardTitle>
        {isLoading ? (
          <LoadingTableNormal countColumn="11" countRow="3" />
        ) : (
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead>
                <tr>
                  <th>{t("detail.reminder.frame_date")}</th>
                  <th>{t("detail.reminder.from_date")}</th>
                  <th>{t("detail.reminder.to_date")}</th>
                  <th>{t("detail.reminder.mon")}</th>
                  <th>{t("detail.reminder.tue")}</th>
                  <th>{t("detail.reminder.wed")}</th>
                  <th>{t("detail.reminder.thu")}</th>
                  <th>{t("detail.reminder.fri")}</th>
                  <th>{t("detail.reminder.sat")}</th>
                  <th>{t("detail.reminder.sun")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data?.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>
                          {
                            timeSlotMenuDefault?.find(
                              n => n.id === item.timeslot_id
                            )?.name
                          }
                        </td>
                        <td>{item?.from_date}</td>
                        <td>{item?.to_date}</td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.mon}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.tue}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.wed}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.thu}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.fri}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.sat}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            defaultChecked={item?.sun}
                            disabled
                          />
                        </td>
                        {rowActions.map((action, index1) => {
                          return (
                            <React.Fragment key={"" + index1 + item?.id}>
                              <div
                                id={"action" + index1 + item?.id}
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={event => {
                                  event.stopPropagation();
                                  action.onClick && action.onClick(item, index);
                                }}
                              >
                                {action.icon}
                                <UncontrolledTooltip
                                  placement="top"
                                  target={"action" + index1 + item?.id}
                                >
                                  {action.text}
                                </UncontrolledTooltip>
                              </div>
                            </React.Fragment>
                          );
                        })}
                        {/*<td><i onClick={clickDeleteHandler(item)} className="fas fa-trash fa-lg text-danger" /></td>*/}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="text-center" colSpan="11">
                      {t("detail.history.table_empty")}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

OrderDetailReminder.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  isDeletingReminder: PropTypes.bool,
  deleteOrderRemind: PropTypes.func,
};
export default OrderDetailReminder;
